import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ROUTES } from "../../app/routes";
import axios from "axios";

const initialState = {
  data: null,
  status: "idle",
  error: null as string | null,
};

export const fetchEmpOracleDetails = createAsyncThunk(
  "empOracleDetails/fetchEmpOracleDetails",
  async (empId: string, { rejectWithValue }) => {
    try {
        const response: { success: boolean; data: any } = await axios({
        method: "get", 
        url:
         `${ROUTES.getEmpOracleDetails}?empId=${empId}`,
         withCredentials : true,
        // headers: {
        //   Authorization: `Bearer ${localStorage.getItem("cc-access-token")}`,
        // },
      });
      
      return response;

      
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch Oracle details");
    }
  }
);

const empOracleDetailsSlice = createSlice({
  name: "empOracleDetails",
  initialState,
  reducers: {
     resetEmpOracleDetails: (state) => {
      state.data = null;
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmpOracleDetails.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchEmpOracleDetails.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload.data as any;
      })
      .addCase(fetchEmpOracleDetails.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      });
  },
});

export const { resetEmpOracleDetails } = empOracleDetailsSlice.actions;

export default empOracleDetailsSlice.reducer;
